import React, { useState } from "react"
import { createContainer } from "unstated-next"
import IResult from "../models/result/IResult";
import * as voicifyApi from '../api';
import ResponseInstanceModel from "../models/features/api/ResponseInstanceModel";
// base representation of a term
interface ResponseInfo {
    id?: string,
    usedIn?: {
        contentItemId: string,
        applicationFeatureId?: string,
        responseInstanceId?: string,
        featureTypeId?: string
    }[]
}
function useResponsesContainer() {
    const [responseInfos, setResponseInfos] = useState<ResponseInfo[]>([])
    const [responses, setResponses] = useState<ResponseInstanceModel[]>([])
    const [currentApp, setCurrentApp] = useState<string>("");
    const [loadingApplicationResponses, setLoadingAppResponses] = useState(false)
    const [loading, setLoading] = useState(false);
    const loadResponse = async (responseId: string, withFollowUp: boolean = false) =>{
        try {
            setLoading(true);
            const newResponses = responseInfos.filter((response) => response.id !== responseId);
            const response = await voicifyApi.getResponse(responseId);
            setLoading(false);
            if (response.resultType === "Ok") {
                if (withFollowUp) {
                    const followUpResponse = await voicifyApi.findFollowUpById(response.data.followUpId);
                    if (followUpResponse.resultType === "Ok") {
                        response.data.followUp = followUpResponse.data;
                    }
                    if (followUpResponse.resultType === "Ok") {
                        response.data.followUp = followUpResponse.data;
                    }
                }
                newResponses.push({
                    id: response.data.id,
                    usedIn: response.data.usedIn
                });
                setResponseInfos(newResponses);
                return response.data;
            }
            return null;
        } catch (e) {
        }
    }
    const loadApplicationResponses = async (applicationId: string, force: boolean = false) => {
        try {
            if (!force && (loadingApplicationResponses || currentApp === applicationId) ) {
                return;
            }
            setLoading(true);
            setLoadingAppResponses(true);
            const allResponses = [];
            let skip = 0;
            const take = 200;
            while (true) {
                const response = await voicifyApi.getResponsesForApplication(applicationId, skip, take);
                if (response.resultType === "Ok") {
                    if (response.data.length) {
                        allResponses.push(...response.data);                        
                    }

                    if (response.data.length === 0) {
                        break;
                    }
                    skip += take;
                }
            }
            setLoading(false);
            setResponses(allResponses);
            setLoadingAppResponses(false);
            setCurrentApp(applicationId);
        } catch (e) {
        }
    }
    const deleteResponse = async (responseId: string) => {
        try {
            setLoading(true);
            const response = await voicifyApi.deleteResponse(responseId);
            setLoading(false);
        } catch (e) {
        }
    }

    return {
        responseInfos, 
        responses,
        loadResponse,
        loadApplicationResponses,
        deleteResponse,
        loading
    };
}

const ResponsesContainer = createContainer(useResponsesContainer);
export default ResponsesContainer;
